import { FC } from 'react'
import { useTranslation } from 'react-i18next'
import { ProductDTO } from 'models/product'
import { DetailField, DetailSection } from '../../common'

interface Props {
  products: ProductDTO[]
}

export const ProductListingSection: FC<Props> = ({ products }) => {
  const { t } = useTranslation(['product', 'gallery'])

  if (!products || products.length === 0) return null

  return (
    <DetailSection title={t('gallery:assignment_details.products')}>
      {products.map((product) => (
        <DetailField
          key={product.id}
          label={t(`product:p_${product.id}`)}
          value={`${product.quantity}x`}
        />
      ))}
    </DetailSection>
  )
}
